import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SideNavRoute } from '../../../../models/SideNavRoute';
import { SideNavService } from '../../../../services/side-nav.service';
import { CoreModule } from '../../../core.module';

@Component({
  selector: 'stine-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)'),
      ),
    ]),
  ],
  standalone: true,
  imports: [CommonModule, CoreModule],
})
export class MenuListItemComponent implements OnInit {
  @Input() sideNavRoute!: SideNavRoute;
  @Input() depth: number = 0;
  public expanded: boolean;
  @HostBinding('attr.aria-expanded') ariaExpanded: boolean;

  constructor(
    public navService: SideNavService,
    public router: Router,
  ) {
    this.expanded = false;
    this.ariaExpanded = this.expanded;
  }

  ngOnInit(): void {
    if (this.depth === undefined) {
      this.depth = 0;
    }
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.sideNavRoute?.route && url) {
        this.ariaExpanded = this.expanded;
      }
    });
  }

  public onItemSelected(sideNavRoute: SideNavRoute): void {
    this.router.navigate([sideNavRoute?.route]);
    this.navService.close();
  }

  public expandCollapse($event: any): void {
    $event.stopPropagation();
    this.expanded = !this.expanded;
    this.ariaExpanded = this.expanded;
  }
}
